import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  initialize({ modelProperty }) {
    this.modelProperty = modelProperty;
    this.listenTo(this.model, 'change', this.render);
  },

  context() {
    return {
      image: this.model.escape(this.modelProperty),
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/brand/image_preview/index.js